// @flow
import React from 'react';
import Modal from 'react-modal';
import SimpleBar from 'simplebar-react';
import { GetInTouchForm } from 'components/organisms/getInTouchForm';
import { useViewport } from 'components/templates/viewportProvider';
import chevronRightIcon from 'assets/images/rightb.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  isOpen: boolean,
  onClosePress: () => void,
  campaignCode?: string,
  projectInterested?: string,
};

export const GetInTouchModal = (props: Props) => {
  const { isMobile } = useViewport();
  const {
    isOpen,
    onClosePress,
    campaignCode,
    projectInterested,
    callPostLeadAPI,
    salesEmail,
    rentalName,
    referenceNumber,
    rental,
    verticalId,
  } = props;

  const onClose = () => {
    onClosePress();
  };

  const fetchUrl = window.location.href;
  const url = new URL(fetchUrl);
  const utmParameters = {
    UTMSource: url.searchParams.get('utm_source'),
    UTMMedium: url.searchParams.get('utm_medium'),
    UTMCampaign: url.searchParams.get('utm_campaign'),
    UTMDisplay: url.searchParams.get('utm_display'),
    UTMTerm: url.searchParams.get('utm_term'),
    UTMContent: url.searchParams.get('utm_content'),
    CampaignCode: campaignCode ? campaignCode : '',
    ProjectInterested: projectInterested ? projectInterested : '',
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClosePress}
      overlayClassName={'modal-overlay normal-scroll'}
      className={`get-in-touch-overlay-content ${isMobile ? 'mobile' : ''}`}
    >
      <div className={'get-in-touch-modal'}>
        <a className={'collapse-icon-container'} onClick={onClose}>
          <img src={chevronRightIcon} alt={'icon'} />
        </a>
        <SimpleBar autoHide={true} style={{ height: '100%' }}>
          <div>
            {/*<span className={'label'}>For more information,</span>*/}
            <h2>For more information, get in touch</h2>
            <h3 className={'get-text'}>We'll get back to you.</h3>
          </div>
          <GetInTouchForm
            onSubmitSuccess={onClose}
            isMobile={isMobile}
            utmParameters={utmParameters}
            salesEmail={salesEmail}
            callPostLeadAPI={callPostLeadAPI}
            rentalName={rentalName}
            referenceNumber={referenceNumber}
            rental={rental}
            verticalId={verticalId}
          />
        </SimpleBar>
      </div>
    </Modal>
  );
};
